export class Sliderhomepage {

	init() {
		$( '.sliders' ).slick( {
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
		} )
	}
}


// WEBPACK FOOTER //
// ./scripts/components/slider-homepage.js